import { render, staticRenderFns } from "./YouMayAlsoLike.vue?vue&type=template&id=6f89de5a&scoped=true"
import script from "./YouMayAlsoLike.vue?vue&type=script&lang=js"
export * from "./YouMayAlsoLike.vue?vue&type=script&lang=js"
import style0 from "./YouMayAlsoLike.vue?vue&type=style&index=0&id=6f89de5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89de5a",
  null
  
)

export default component.exports